module.exports = __webpack_public_path__ + "43d5342998f3607bd61a8239e98b1160.eot";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/OpenSans-Italic-webfont.eot
// module id = 622
// module chunks = 0